import type { ReactNode } from "react";

import { Spacer, ThemeToggle } from "@aviary";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { useFlippers } from "@shared/hooks/useFlippers/useFlippers";

import { FooterLogos } from "./FooterLogos/FooterLogos";
import { FooterPrivacy } from "./FooterPrivacy/FooterPrivacy";

import * as styles from "./AuthFooter.styles";

interface Props {
  children?: ReactNode;
}

const AuthFooter = ({ children }: Props) => {
  const { tablet } = useBreakpoints();
  const [isIAMLoginDS4] = useFlippers("iam_login_ds4");

  const renderContent = () => {
    if (tablet.greaterThan) {
      return (
        <>
          <div>
            <FooterLogos />
          </div>
          <div>
            {children}
            <FooterPrivacy />
          </div>
          <div>{!!isIAMLoginDS4 && <ThemeToggle />}</div>
        </>
      );
    }

    return (
      <div css={styles.mobileWrapper}>
        {children}
        <Spacer height="double" />
        <FooterLogos />
        <Spacer height="oneHalf" />
        <FooterPrivacy />
        {!!isIAMLoginDS4 && <ThemeToggle />}
      </div>
    );
  };

  return (
    <footer css={[styles.footer, tablet.greaterThan && styles.topBorder]}>
      <div css={styles.wrapper}>{renderContent()}</div>
    </footer>
  );
};

export { AuthFooter };
